import {
    Component,
    Output,
    EventEmitter,
    Input,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NovaServiceService } from '../../../services/nova-service.service';
import { NovaDaterangePickerComponent } from '../nova-daterange-picker/nova-daterange-picker.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'nova-date-range-filter',
  standalone: true,
  imports: [CommonModule, NovaDaterangePickerComponent],
  templateUrl: './nova-date-range-filter.component.html',
  styleUrl: './nova-date-range-filter.component.scss',
})
export class NovaDateRangeFilterComponent implements OnInit, OnDestroy {
  @Input() openUpward: boolean = false;
  @Output() onDateRangeChange = new EventEmitter<{ start_date: string; end_date: string }>();

  /** Current range from service (conversation-specific); passed to picker so it stays in sync when conversation changes. */
  currentRangeFromService: string[] | null = null;

  private dateRangeSubscription?: Subscription;
  private conversationSubscription?: Subscription;
  private contextAppliedSubscription?: Subscription;

  constructor(private novaService: NovaServiceService) {}

  ngOnInit(): void {
    this.syncRangeFromService();
    this.conversationSubscription = this.novaService.currentConversation$.subscribe(() => {
      this.syncRangeFromService();
    });
    this.contextAppliedSubscription = this.novaService.novaContextApplied$.subscribe(() => {
      this.syncRangeFromService();
    });
  }

  private syncRangeFromService(): void {
    const context = this.novaService.getNovaChatContext();
    if (context.start_date && context.end_date) {
      this.currentRangeFromService = [context.start_date, context.end_date];
      this.onDateRangeChange.emit({
        start_date: context.start_date,
        end_date: context.end_date,
      });
    } else {
      this.currentRangeFromService = ['', ''];
    }
  }

  ngOnDestroy(): void {
    this.dateRangeSubscription?.unsubscribe();
    this.conversationSubscription?.unsubscribe();
    this.contextAppliedSubscription?.unsubscribe();
  }

  /**
   * Handle date selection from the NOVA date range picker
   */
  onDateSelect(dateRange: string | string[]): void {
    if (Array.isArray(dateRange) && dateRange.length === 2) {
      const [start_date, end_date] = dateRange;

      // Update NOVA service with new date range
      this.novaService.setNovaDateRange(start_date, end_date);
      this.onDateRangeChange.emit({ start_date, end_date });
    }
  }
}
